export default __webpack_public_path__ + "static/media/ulucinar1.32fbb1ec.jpg";